module.exports = __webpack_public_path__ + "img/productProfile.975a834e.svg";